import React from 'react';

import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as RefreshIcon } from '../../assets/images/refresh_icon.svg';
import { ReactComponent as WarningIcon } from '../../assets/images/warning_icon_orange.svg';
import { t } from '../../providers/TranslationProvider';

const useStyles = makeStyles((theme) => ({
    accessMultimedia: {
        position: 'absolute',
        top: '140px',
        right: '10px',
        marginTop: '4px',
        textAlign: 'center',
        color: 'rgb(8, 107, 156)',
        minWidth: '40px',
        padding: '5.5px 4px',
        borderRadius: '2px',
        cursor: 'pointer',
        fontSize: '0.625rem',
        textTransform: 'uppercase',
        fontWeight: '600',
        letterSpacing: '0.5px',
    },
    errorMessageappImageGrid: {
        background: '#FEF3C7',
        borderRadius: '2px',
        color: '#3D1B0A',
        fontSize: '0.875rem',
        textAlign: 'center',
        verticalAlign: 'middle',
        letterSpacing: '-0.2px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        lineHeight: '142%',
        float: 'left',
        padding: '8px 16px',
        '& span': {
            marginLeft: '5.65px',
        },
    },
    errorMessageappImage: {
        background: '#FEF3C7',
        borderRadius: '2px',
        color: '#3D1B0A',
        fontSize: '0.75rem',
        textAlign: 'center',
        verticalAlign: 'middle',
        letterSpacing: '-0.2px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        lineHeight: '142%',
        float: 'left',
        padding: '1px 6px',
        '& span': {
            margin: '0',
        },
    },
    refreshButton: {
        color: '#3F5E20',
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '15.96px',
        letterSpacing: '0.5px',
        textAlign: 'left',
        padding: '0px',
        fontFamily: theme.typography.body1.fontFamily,
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    errorSectionappImage: {
        width: '164px',
        background: '#F9FAFB',
        height: '100%',
        padding: '0px 12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& .refreshButton': {
            svg: {
                width: '13.32px',
                height: '13.34px',
            },
        },
    },
    errorSectionappImageGrid: {
        width: '100%',
        background: '#F9FAFB',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));

const ErrorImage = ({ imageClass, action, imageId, selectedTab, application }) => {
    const { denomination } = application;
    const classes = useStyles();
    return (
        <div className={classes[`errorSection${imageClass}`]}>
            <div className={classes[`errorMessage${imageClass}`]}>
                {imageClass === 'appImageGrid' && (
                    <WarningIcon aria-hidden="true" focusable="false" style={{ width: '12.71px', height: '11.34px', verticalAlign: 'middle' }} />
                )}
                <span>{t('error.loading.images')}</span>
                {imageClass === 'appImageGrid' && (
                    <div className={classes.accessMultimedia}>
                        <IconButton
                            disableFocusRipple
                            className={classes.refreshButton}
                            onClick={() => {
                                action(imageId, selectedTab);
                            }}
                            aria-label={`${t('refresh.image')} ${denomination}`}>
                            {t('refresh.button.text')}
                            <RefreshIcon
                                style={{ paddingLeft: '6.68px' }}
                                role="image"
                                aria-label={t('refresh.image')}
                                aria-hidden="true"
                                focusable="false"
                            />
                        </IconButton>
                    </div>
                )}
            </div>
            {imageClass !== 'appImageGrid' && (
                <IconButton
                    aria-label={`${t('refresh.image')} ${denomination}`}
                    className={classes.refreshButton}
                    onClick={() => {
                        action(imageId, selectedTab);
                    }}>
                    <RefreshIcon
                        style={{ paddingLeft: '6.68px' }}
                        aria-label={t('refresh.image')}
                        aria-hidden="true"
                        focusable="false"
                        role="image"
                    />
                </IconButton>
            )}
        </div>
    );
};

export default ErrorImage;
